"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackClickToCancelDay = void 0;
const enums_1 = require("../enums");
const trackGA4EventWithCleanUp_1 = require("./trackGA4EventWithCleanUp");
const trackClickToCancelDay = (clickElement) => {
    const bookingEvent = {
        event: 'JS_Event',
        eventData: {
            eventName: enums_1.GA4EventName.ClickButton,
            feature_category: enums_1.GA4FeatureCategory.DirectBooking,
            click_element: clickElement,
        },
    };
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)(bookingEvent);
};
exports.trackClickToCancelDay = trackClickToCancelDay;
//# sourceMappingURL=trackClickToCancelDay.js.map